<template>
  <b-tooltip position="is-left" :label="$t('question.AllFolding')">
    <div
      style="margin-left:10px; margin-top:5px;"
      @click="foldingQuestioFunction('add')"
      v-if="
        indexSection !== undefined &&
        AllFolding[indexSection] !== undefined &&
        AllFolding[indexSection].questions !== undefined
          ? !AllFolding[indexSection].questions.includes(indexQuestion)
          : !AllFolding.includes(indexQuestion)
      "
    >
      <img
        src="@/assets/img/icons/fold-icon.png"
        class="icon"
        alt="icon-fold"
      />
    </div>
    <div @click="foldingQuestioFunction('remove')" v-else>
      <img
        src="@/assets/img/icons/fold-icon.png"
        style="transform: rotate(180deg);"
        class="icon"
        alt="icon-fold"
      />
    </div>
  </b-tooltip>
</template>

<script>
export default {
  name: 'ButtonFoldingQuestion',
  props: {
    idQuestion: Number,
    AllFolding: Array,
    indexQuestion: Number,
    indexSection: Number
  },
  methods: {
    foldingQuestioFunction (type) {
      this.$store.commit('FOLDING_QUESTION', {
        type: type,
        indexQuestion: this.indexQuestion,
        indexSection: this.indexSection
      })
    }
  }
}
</script>
<style scoped>
.icon {
  width: 15px;
  height: 15px;
  margin-top: 4px;
  margin-left: 10px;
  vertical-align: center;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/question/components/ButtonFoldingQuestion.vue